// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__yC19E"};